'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _makerStore = require('./stores/makerStore');

var _makerStore2 = _interopRequireDefault(_makerStore);

var _loadCharts = require('./loadCharts');

var _loadCharts2 = _interopRequireDefault(_loadCharts);

var _reportMaker = require('./components/maker/reportMaker');

var _reportMaker2 = _interopRequireDefault(_reportMaker);

var _ACS = require('./components/acs/ACS');

var _ACS2 = _interopRequireDefault(_ACS);

var _Regions = require('./components/settings/Regions');

var _Regions2 = _interopRequireDefault(_Regions);

var _ExchangeRates = require('./components/settings/ExchangeRates');

var _ExchangeRates2 = _interopRequireDefault(_ExchangeRates);

var _Import = require('./components/data/Import');

var _Import2 = _interopRequireDefault(_Import);

var _Budget = require('./components/data/Budget');

var _Budget2 = _interopRequireDefault(_Budget);

var _Notes = require('./components/notes/Notes');

var _Notes2 = _interopRequireDefault(_Notes);

var _OrderHistory = require('./components/directory/OrderHistory');

var _OrderHistory2 = _interopRequireDefault(_OrderHistory);

var _Filters = require('./components/directory/Filters');

var _Filters2 = _interopRequireDefault(_Filters);

var _ReactTable = require('./components/reports/ReactTable');

var _ReactTable2 = _interopRequireDefault(_ReactTable);

var _Search = require('./components/search/Search');

var _Search2 = _interopRequireDefault(_Search);

var _BrandSummary = require('./components/reports/BrandSummary');

var _BrandSummary2 = _interopRequireDefault(_BrandSummary);

var _DepartmentUpdateOptions = require('./components/reports/DepartmentUpdateOptions');

var _DepartmentUpdateOptions2 = _interopRequireDefault(_DepartmentUpdateOptions);

var _OrderEdit = require('./data/OrderEdit');

var _OrderEdit2 = _interopRequireDefault(_OrderEdit);

var _deleteContact = require('./stores/deleteContact');

var _deleteContact2 = _interopRequireDefault(_deleteContact);

var _global = require('./global');

var _global2 = _interopRequireDefault(_global);

var _dropzones = require('./dropzones');

var _dropzones2 = _interopRequireDefault(_dropzones);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Load Charts
var myCharts = new _loadCharts2.default();

var reportMakerNode = document.getElementById('report-creator');
if (reportMakerNode) {
	_reactDom2.default.render(_react2.default.createElement(
		_reactRedux.Provider,
		{ store: _makerStore2.default },
		_react2.default.createElement(_reportMaker2.default, null)
	), reportMakerNode);
}

var ACSNode = document.getElementById('acs-root');
if (ACSNode) {
	_reactDom2.default.render(_react2.default.createElement(_ACS2.default, null), ACSNode);
}

var RegionsNode = document.getElementById('settings-regions');
if (RegionsNode) {
	_reactDom2.default.render(_react2.default.createElement(_Regions2.default, null), RegionsNode);
}

var ImportNode = document.getElementById('import');
if (ImportNode) {
	_reactDom2.default.render(_react2.default.createElement(_Import2.default, null), ImportNode);
}

var BudgetNode = document.getElementById('new-budget');
if (BudgetNode) {
	_reactDom2.default.render(_react2.default.createElement(_Budget2.default, null), BudgetNode);
}

var NotesNode = document.getElementById('notes');
if (NotesNode) {
	_reactDom2.default.render(_react2.default.createElement(_Notes2.default, null), NotesNode);
}

var OrderHistoryNode = document.getElementById('order-history');
if (OrderHistoryNode) {
	_reactDom2.default.render(_react2.default.createElement(_OrderHistory2.default, null), OrderHistoryNode);
}

var ExchangeRatesNode = document.getElementById('settings-exchange_rates');
if (ExchangeRatesNode) {
	_reactDom2.default.render(_react2.default.createElement(_ExchangeRates2.default, null), ExchangeRatesNode);
}

var FiltersNode = document.getElementById('filters');
if (FiltersNode) {
	window.filters_component = _reactDom2.default.render(_react2.default.createElement(_Filters2.default, null), FiltersNode);
}

var domElement = document.getElementById('react-table');
if (domElement) {
	window.reactTable = _reactDom2.default.render(_react2.default.createElement(_ReactTable2.default, null), domElement);
}

var SearchNode = document.getElementById('search');
if (SearchNode) {
	_reactDom2.default.render(_react2.default.createElement(_Search2.default, null), SearchNode);
}

var ReportNode = document.querySelector('.report__brand-summary');
if (ReportNode) {
	_reactDom2.default.render(_react2.default.createElement(_BrandSummary2.default, null), ReportNode);
}

var UpdatesNode = document.querySelector('.department-update-options__react-root');
if (UpdatesNode) {
	_reactDom2.default.render(_react2.default.createElement(_DepartmentUpdateOptions2.default, null), UpdatesNode);
}

if (document.querySelector('.data-editorder')) {
	(0, _OrderEdit2.default)('.data-editorder');
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/app.js
// module id = 1127
// module chunks = 0